package com.iregained.site.components.sections.product.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

val ProductOverviewImageStyle = CssStyle {
    base {
        val palette = colorMode.toSitePalette()
        Modifier
            .boxShadow(0.px, 15.px, 35.px, color = palette.custom.darkText.toRgb().copyf(alpha = 0.08f))
            .transition(Transition.of("transform", 0.4.s))
    }
    hover {
        Modifier.scale(1.02)
    }
}